var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateRoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x9C Icon / Bold/Door"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector",
    d: "M2.25 21H21.75",
    stroke: "#8247E5",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_2",
    d: "M5.25 21V3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3H18C18.1989 3 18.3897 3.07902 18.5303 3.21967C18.671 3.36032 18.75 3.55109 18.75 3.75V21",
    stroke: "#8247E5",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_3",
    d: "M14.625 13.5C15.4534 13.5 16.125 12.8284 16.125 12C16.125 11.1716 15.4534 10.5 14.625 10.5C13.7966 10.5 13.125 11.1716 13.125 12C13.125 12.8284 13.7966 13.5 14.625 13.5Z",
    fill: "#8247E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRoom);
export default __webpack_public_path__ + "static/media/create-room.06b74b42a2718bfb8c1b7c159d59bdf4.svg";
export { ForwardRef as ReactComponent };